import * as React from 'react';
import PropTypes from 'prop-types';
import t from '../../i18n/I18n';
import "./DropDown2.css";

export default class DropDown2 extends React.Component {
  static propTypes = {
    classes: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    disable: PropTypes.bool,
    value: PropTypes.string,
    index: PropTypes.number,
    style: PropTypes.object
  };

  static defaultProps = {
    classes: 'form-control form-control-sm',
    value: '',
    options: [],
    disable: false,
    style: { }
  };

  onChange = (e) => {
    if (this.props.index) {
      this.props.onChange(e.target.value, this.props.index);
    } else {
      this.props.onChange(e.target.value);
    }
  };

  renderOptions = (option, i) => {
    return (
      <option key={i}  value={option.value}>
        {option.label}
      </option>
    );
  };

  render() {
    const { classes, style={}, options, onChange, disable, value } = this.props;
    const defaultValue = value || 'DEFAULT';
    return (
      <select name="DropDown2" value={defaultValue} onChange={this.onChange} style={{backgroundImage:"url('images/arrow_down.svg')",...style}} className={classes}>
        <option value="DEFAULT" disabled hidden>
          {t('SELECT_REGION')}
        </option>
        {options.map(this.renderOptions)}
      </select>
    );
  }
}
